import React, { useState } from 'react';
import HighlightOverlay from '../components/highlight-overlay';

/**
 * Rich-renderer function that can be consumed by React-Rich-Text render in order
 * to generate a styled element based on a particular rich text node, and it's
 * children
 *
 * @function
 * @param {object} reference
 */
const RichAsset = reference => {
  let content = null;
  const [isOpen, setIsOpen] = useState(false);

  if (reference?.internal?.type === 'ContentfulAsset') {
    content = (
      <>
        <img
          style={{ display: 'block', margin: '10px auto', cursor: 'zoom-in' }}
          src={reference?.file?.url}
          alt={reference?.title || ''}
          onClick={() => setIsOpen(true)}
        />
        <HighlightOverlay
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          image={reference?.file?.url}
          alt={reference?.title}
        />
      </>
    );
  }

  return content;
};

export default RichAsset;
